const errConfig = {
	2000001:{
		tip: '您已经领取过奖励啦！请下次参加！',
		type: 'alert' 
	},
	2000002:{
		tip: '您的区域不是活动区域',
		type: 'alert' 
	},
	2000003:{
		tip: '活动目前无法参加',
		type: 'alert' 
	},
	2000005:{
		tip: '速度太快了，休息一会再试试',
		type: 'alert' 
	},
	2000006:{
		tip: '不在活动时间范围内',
		type: 'alert' 
	},
	2000007:{
		tip: '礼物领取失败，请与客服联系',
		type: 'alert' 
	},
	2000008:{
		tip: '当前处于游客模式',
		type: 'login' 
	},
	1000000:{
		tip: '系统错误',
		type: 'alert'
	}
}

const defaultConfig = {
	tip: '系统错误',
	type: 'alert'
}

function getErrConfig(errcode){
	if(errConfig[errcode]){
		return errConfig[errcode];
	}else {
		return defaultConfig;
	}
}
module.exports = getErrConfig;


// WEBPACK FOOTER //
// ./js/component/task/error_config.js